import { isSet as isSet$1 } from '../../predicate/isSet.mjs';

function isSet(value) {
    return isSet$1(value);
}

export { isSet };
